import React from 'react';

import { PaddingContainer, QuoteWithPhoto, WidthContainer } from '@components';
import BarketImage from '@images/staff/bartek.webp';
import { colors } from '@styles/core-styles/theme';

export const Quote: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<QuoteWithPhoto
					background={colors.yellowOrangeGradient}
					photoOnLeft
					flipImage
					image={BarketImage}
					author="Bartek, cto"
				>
					<p className="font-size-sm">
						We are changing most non-standard ideas into tailored software
						solutions. Every project is started by defining goals, requirements
						and expectations. Plus, used technologies are matched to solutions,
						not conversely.
					</p>
				</QuoteWithPhoto>
			</WidthContainer>
		</PaddingContainer>
	);
};
